<template>
  <v-container fluid>
    <v-row>
      <v-col class="main_title">
        <v-flex tag="h2" class="primary-text">
          Analytics
          <v-tooltip bottom>
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-bind="attrs" v-on="on">
                information
              </v-icon>
            </template> -->
            <span>Value Stream Metrics</span>
          </v-tooltip>
        </v-flex>
        <v-divider class="mt-4" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="innercontainer">
          <v-row>
            <v-col cols="6" md="4">
              <v-card class="pa-3 innercards">
                <h5>Demo Users Vs Paid Users</h5>
                <div class="chart">
                  <demo-vs-clients :chartData="demovsclient"></demo-vs-clients>
                </div>
              </v-card>
            </v-col>
            <v-col cols="6" md="4">
              <v-card class="pa-3 innercards">
                <h5>Setup My Agency Vs Setup My Clients</h5>
                <div class="chart">
                  <company-vs-clients :chartData="agencyCountvsownCompanyCount"></company-vs-clients>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card class="innercards pa-3">
                <h5>Number of users selected setup My Company</h5>
                <v-row>
                  <v-col md="4" class="pb-0">
                    <v-text-field
                      v-model="search"
                      label="Search"
                      prepend-inner-icon="search"
                      class="search-control"
                      @keyup="getVsmList(), pageReset()"
                    />
                  </v-col>
                </v-row>
                <v-row class="custom-simple-table">
                  <v-col>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left"> Name </th>
                            <th class="text-left"> Email </th>
                            <th class="text-left"> Company </th>
                            <th class="text-left"> Tier </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="n in 5" :key="`none-${n}`">
                            <td>Thomas Magnum</td>
                            <td>thomas@ibm.com</td>
                            <td>IBM</td>
                            <td>Demo</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '@/store/actions.constants';
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
import DemoVsClients from './DemoVsClients.vue';
import CompanyVsClients from './CompanyVsClients.vue';
export default {
  components: { licensePagination,DemoVsClients,CompanyVsClients },
  data: () => ({
    headers: [
      {
        text: 'Departments',
        align: 'start',
        value: 'name',
      },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    loading: false,
    page: 1,
    itemsPerPage: 10,
    sortDesc: [],
    options: {},
    valid: false,
    departmentName: null,
    isDuplicate: false,
    text: '',
    departmentObj: {},
    nameRules: [
      (v) => !!v || 'Department is Required',
      (v) =>
        (v.length > 0 && /^[^\s]/.test(v)) ||
        'Initial character should not be a space',
      (v) =>
        !!(v && v.toString().split('  ').length <= 1) ||
        'Only one space is allowed in between 2 words',
      (v) =>
        !!(v.trim().length > 2 && v.trim().length < 21) ||
        'String length should be between 3 to 20',
      (v) => /^([^0-9]*)$/.test(v) || 'Numbers not allowed',
    ],
    addDepartmentVisibility: false,
    editDepartmentVisibility: false,
    demovsclient:[],
    agencyCountvsownCompanyCount:[]
  }),
  computed: {
    ...mapGetters({
      getDemoUsers: 'analytics/getDemoUsers',
      getAgencyUsers: 'analytics/getAgencyUsers',
    }),
  },
  async mounted() {
     await this.getDemoPaidUsersList(),
     await this.getAgencyOwnUsersList();
  },
  methods: {
    ...mapActions({
      getDemoPaidUsers: 'analytics/getDemoPaidUsers',
      getAgencyOwnUsers: 'analytics/getAgencyOwnUsers',
      
    }),
    getDemoPaidUsersList() {
      debugger
      this.getDemoPaidUsers()
        .then((res) => {
          if (res.status === 200) {
          this.demovsclient=res.data
          console.log(this.demovsclient,res.data)
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    getAgencyOwnUsersList() {
      debugger
      this.getAgencyOwnUsers()
        .then((res) => {
          if (res.status === 200) {
          this.agencyCountvsownCompanyCount=res.data
          console.log(this.agencyCountvsownCompanyCount,res.data)
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
  },
}
</script>


<style lang="scss">
@import '../../assets/scss/colors.scss';
.main_title {
  h2 {
    .v-icon {
      font-size: 24px;
      position: relative;
      top: -1px;
    }
  }
}
.innercontainer {
  box-shadow: none !important;
  border-radius: 0px !important;
  background-color: $secondary-color-6 !important;
  padding: 8px 16px;
  .innercards {
    box-shadow: none !important;
    border-radius: 0px !important;
    padding: 8px;
    h5 {
      font-size: 15px;
      font-weight: 500;
      margin: 0 0 10px;
    }
    .chart {
      text-align: center;
    }
    .search-control {
      padding-top: 0px;
      margin-top: 0px;
    }
  }
}
</style>